import { AlignItems, Box, Button, ButtonColorVariant, Color, Display, Icon, IconVariant, Space } from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'
import React from 'react'
import css from './CancelOrderModalContent.css'

const propTypes = {
  orderId: PropTypes.string,
  didCancelOrderError: PropTypes.bool,
  close: PropTypes.func,
  orderCancel: PropTypes.func,
  cancelOrderModalToggleVisibility: PropTypes.func,
}

const defaultProps = {
  orderId: '',
  didCancelOrderError: false,
  close: () => { },
  orderCancel: () => { },
  cancelOrderModalToggleVisibility: () => { },
}

export class CancelOrderModalContent extends React.PureComponent {
  handleCancelBox = () => {
    const { orderCancel, cancelOrderModalToggleVisibility, orderId } = this.props
    orderCancel(orderId)
      .then(() => cancelOrderModalToggleVisibility(false, orderId))
  }

  render() {
    const { close, didCancelOrderError } = this.props

    return (
      <div className={css.body}>
        <h2 className={css.modalTitle}>Cancel this box?</h2>
        <div className={css.modalBodyText}>
          Just double-checking – if you click yes, we can’t restore this delivery. Please confirm your choice:
        </div>
        {didCancelOrderError ? (
          <Box
            display={Display.Flex}
            alignItems={AlignItems.Center}
            gap={2}
            borderRadius={1}
            paddingH={3}
            paddingV={3}
            bg={Color.Error_50}
            style={{
              fontSize: '0.875rem',
              marginBottom: '1.5rem',
              minHeight: '1.25rem',
            }}
          >
            <Icon
              name="error"
              variant={IconVariant.Error}
              style={{ alignSelf: 'flex-start' }}
            />
            <p style={{ margin: 0 }}>
              Whoops, there was a problem cancelling this order, please try again.
            </p>
          </Box>
        ) : null}
        <div className={css.bottom}>
          <Button colorVariant={ButtonColorVariant.Warning} data-testing="cancelOrderCancelButton" onClick={close}>
            Go Back
          </Button>
          <Space size={2} direction="horizontal" />
          <Button colorVariant={ButtonColorVariant.Primary} data-testing="cancelOrderConfirmButton" onClick={() => this.handleCancelBox()}>
            Cancel Box
          </Button>
        </div>
      </div>
    )
  }
}

CancelOrderModalContent.propTypes = propTypes
CancelOrderModalContent.defaultProps = defaultProps
